'use client';

import { useApiClient } from '@/hooks/useApiClient';

export function useDeleteComment(feedbackId: string, metaSiteId: string) {
  const apiClient = useApiClient();

  async function deleteComment(commentId: string): Promise<void> {
    await apiClient.post('api/delete-comment', {
      feedbackId,
      metaSiteId,
      commentId,
    });
  }

  return { deleteComment };
}
